import {ChangeDetectionStrategy, Component, EventEmitter, inject, input, Output, output} from '@angular/core';
import {ClearIncomeNycIdCommand, HouseholdMemberDto, ResetSyncStatusCommand} from "admin-api-dto";
import {Button} from "primeng/button";
import {TableModule} from "primeng/table";
import {TypedTableRowDirective} from "../../typed-table-row.directive";
import {LabeledComponent} from "../labeled/labeled.component";
import {UserService} from "../../services/user.service";

@Component({
  selector: 'app-household-member-details',
  imports: [
    Button,
    TableModule,
    TypedTableRowDirective,
    LabeledComponent
  ],
  templateUrl: './household-member-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HouseholdMemberDetailsComponent {
  public readonly householdMember = input.required<HouseholdMemberDto>();

  public readonly onSync = output<ResetSyncStatusCommand>();
  public readonly onClearNycId = output<ClearIncomeNycIdCommand>();

  public clearNycId(memberId: string, nycId: number | undefined) {
    const result = confirm("Are you sure");

    if (result) {
      this.onClearNycId.emit({
        householdMemberId: memberId,
        nycId: nycId!
      });
    }
  }
}
